import { Link } from "@tanstack/react-router";
import {
  ChevronRight,
  Users,
  Globe,
  ListChecks,
  Lock,
  FileText,
  type LucideIcon,
} from "lucide-react";
import { useLingui } from "@lingui/react/macro";
import type { PopularTopic } from "@/types/help";

const TOPIC_ICONS: Record<string, LucideIcon> = {
  "user-roles-access": Users,
  "locations-region": Globe,
  "recipe-publishing": ListChecks,
  "troubleshooting-permissions": Lock,
};

export function PopularTopicsCard({ topics }: { topics: PopularTopic[] }) {
  const { t } = useLingui();

  return (
    <div className="flex flex-col gap-4 rounded-xl border border-(--gray-200) bg-(--color-surface-page) p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-medium text-(--color-text-primary)">
          {t`Popular topics`}
        </h2>
        <Link
          to="/help-center"
          search={{ category: "all", sort: "newest", view: "list" }}
          className="flex items-center gap-2 text-sm font-medium text-(--gray-600)"
        >
          {t`View all`}
          <ChevronRight className="size-5" />
        </Link>
      </div>

      <ul className="flex flex-col gap-3">
        {topics.map((topic) => {
          const Icon = TOPIC_ICONS[topic.id] ?? FileText;
          return (
            <li key={topic.id}>
              <Link
                to="/help-center/$articleId"
                params={{ articleId: topic.articleId }}
                className="flex items-center gap-3 rounded-xl border border-(--gray-200) bg-(--gray-100) p-3 transition-colors hover:bg-(--gray-200)"
              >
                <span className="flex size-12 shrink-0 items-center justify-center rounded-lg border border-(--gray-200) bg-(--color-surface-page)">
                  <Icon className="size-6 text-(--color-text-primary)" />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-(--color-text-primary)">
                    {topic.title}
                  </p>
                  <p className="truncate text-sm text-(--gray-600)">
                    {topic.description}
                  </p>
                </div>
                <ChevronRight className="size-5 shrink-0 text-(--gray-500)" />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
